<div class="card grid-xpmd text-center">
  <h4 i18n class="my-0">Uw account is verwijderd.</h4>
  <p><a i18n [routerLink]="['/login']">Terug naar Xperience</a></p>
</div>
